export default "__VITE_ASSET__DBHRDc$I__"